import React from "react";
import { Card } from "antd";
import { Heart, Star, Trophy } from "lucide-react";


const ParticipantStatusCard = () => {

  const participantStatus = [
    {
      title: "Total Winners (Year)",
      icon: Trophy,
      count: 45,
      color: "emerald-white",
    },
    {
      title: "Nominations (Month)",
      icon: Star,
      count: 23,
      color: "purple-white",
    },
    {
      title: "Participation Rate",
      icon: Heart,
      count: "87%",
      color: "blue-white",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {participantStatus.map((item) => {
        const Icon = item.icon;
        return(
          <Card
          key={item.id}
          className={`rounded-xl card-border-s ${item.color}`}
        >
          <div className="flex items-center justify-between"> 
            <div>
              <p className="text-[12px] title-text mb-1">{item.title}</p>
              <p className="text-[24px] font-semibold card-text">{item.count}</p>
            </div>
            <div className="icon-theme p-3 rounded-xl">
              <Icon className="w-6 h-6" />
            </div>
          </div>
        </Card>   
        );
      })}
    </div>
  );
};

export default (ParticipantStatusCard);
